import { render, staticRenderFns } from "./DialogOrderPhase.vue?vue&type=template&id=5ee28e96&"
import script from "./DialogOrderPhase.vue?vue&type=script&lang=js&"
export * from "./DialogOrderPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports